import React from 'react';
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'

import { useLocation } from 'react-router-dom';

const NavBar = ({ user, onSidebarOpen }) => {
  const location = useLocation(),
        activeKey = location.pathname === '/' ? 'search' : location.pathname.slice(1);

  return (
    <Navbar collapseOnSelect expand="lg" variant="light" fixed="top" className="color-nav">
      <Navbar.Brand href="/">
        <img className="navbar-logo" src="black_logo.svg" alt="Logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav
          className="ml-auto pt-1"
          activeKey={activeKey}>
          <Nav.Link href="/" eventKey="search">
            <h6>Search</h6>
          </Nav.Link>
          <Nav.Link href="/intel" eventKey="intel">
            <h6>Intel</h6>
          </Nav.Link>
          {!user && (
            <React.Fragment>
              <Nav.Link href="/login" eventKey="login">
                <h6>Login</h6>
              </Nav.Link>
              <Nav.Link href="/register" eventKey="register">
                <h6>Register</h6>
              </Nav.Link>
            </React.Fragment>
            )}
          {user && (
            <React.Fragment>
              <Nav.Link href="/profile" eventKey="profile">
                <h6>{user.username}</h6>
              </Nav.Link>
              <Nav.Link href="/logout">
                <h6>Logout</h6>
              </Nav.Link>
            </React.Fragment>
            )}
        </Nav>
        
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavBar;
